<template>
  <div class="flex flex-wrap">
    <TransitionCollapseWidth>
      <div v-if="formOpened">
        <div class="grid grid-cols-2 col-gap-4 pr-8">
          <AccountsSelect v-model="form.account"
                          class="w-78"
                          :class="{'--error':$v.form.account.$error}"
                          :label="$t('accountFrom')"
                          :accounts="replenishmentAvailableAccounts"
                          :account_groups="replenishmentAvailableAccountsByGroups"
                          :grouped="accounts_by_groups.length > 1">
            <template v-slot:errors>
              <div class="error" v-if="$v.form.account.$invalid">{{ $t('fieldRequired') }}</div>
            </template>
          </AccountsSelect>
          <ValueInput :label="$t('sum')"
                      class="w-78"
                      v-model.trim="$v.form.sum.$model"
                      :currency_id="goal.currency.id"
                      :class="{'--error':$v.form.sum.$error}">
            <template v-slot:errors>
              <div class="error" v-if="$v.form.sum.$invalid">{{ $t('fieldRequired') }}</div>
            </template>
          </ValueInput>
        </div>
      </div>
    </TransitionCollapseWidth>
    <BaseButton theme="red"
                class="lg:w-78"
                :loading="submitted"
                @click.native="handleReplenish">
      {{ $t('replenish') }}
    </BaseButton>
    <BaseButton v-if="formOpened"
                theme="white-bordered"
                class="lg:w-78 ml-8"
                :loading="submitted"
                @click.native="cancel">
      {{ $t('cancel') }}
    </BaseButton>
    <div class="overflow-hidden">
      <transition name="slide">
        <div v-if="formOpened" class="mt-4 text-2sm text-text-ternary w-full transition duration-200">
          {{ $t('commissionTip') }}
          <router-link :to="{name:'transactions'}"
                       class="text-red hover:text-red-hover transition duration-200">
            {{ $t('commissionTipNavigation') }}
          </router-link>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import TransitionCollapseWidth from "@/components/transitions/TransitionCollapseWidth";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";
import ValueInput from "@/components/UI/BaseInput/ValueInput";
import {mapActions, mapGetters, mapState} from "vuex";
import {decimal, required, requiredIf} from "vuelidate/lib/validators";

export default {
  name: "GoalReplenishBalance",
  components: {ValueInput, AccountsSelect, TransitionCollapseWidth, BaseButton},
  props: {
    formOpened: {
      type: Boolean
    },
    goal: {
      type: Object
    }
  },
  data() {
    return {
      submitted: false,
      form: {
        account: null,
        sum: null,
      }
    }
  },
  validations: {
    form: {
      account: {
        required,
      },
      sum: {
        required,
        decimal,
      },
    }
  },
  computed: {
    ...mapState('space/accounts', ['accounts']),
    ...mapGetters('space/accounts', ['accounts_by_groups']),
    replenishmentAvailableAccounts() {
      return [...this.accounts.data].filter(acc => acc.title !== this.goal.account_title)
    },
    replenishmentAvailableAccountsByGroups() {
      return [...this.accounts_by_groups].map(group => ({
        ...group,
        childs: group.childs.filter(acc => acc.title !== this.goal.account_title)
      }))
    }
  },
  methods: {
    ...mapActions('space/goals', ['replenishGoalBalance']),
    async createReplenishment() {
      try {
        this.submitted = true;
        let data = {
          sum: +this.form.sum,
          goal_id: this.goal.id,
          account_id: this.form.account.id
        };

        const res = await this.replenishGoalBalance(data);
        if (res.body.success) {
          this.$emit('toggleForm');
          this.$emit('successReplenishment', res.body.data);
          this.clearFields();
          this.$toasted.success(this.$t('successfullyReplenished'))
        } else {
          this.$toasted.error('Ошибка')
          console.error(res)
        }
      } catch (e) {
        this.$toasted.error('Ошибка')
        console.error(e)
      } finally {
        this.submitted = false;
      }
    },
    async handleReplenish() {
      if (this.formOpened) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          await this.createReplenishment();
        }
      } else {
        this.$emit('toggleForm');
        this.clearFields();
      }
    },
    cancel() {
      this.$emit('toggleForm');
    },
    clearFields() {
      this.form.account = null;
      this.form.sum = null;
      this.$v.$reset();
    }
  },
  i18n: {
    messages: {
      en: {
        newTransactionLabel: 'Empty',
        fieldRequired: 'Field is required',
        accountFrom: 'From account',
        sum: 'Sum',
        replenish: 'Replenish',
        cancel: 'Cancel',
        commissionTip: 'The goal is replenished without commission. If you want to specify a commission, edit the transfer on',
        commissionTipNavigation: 'the Operations page',
        successfullyReplenished: 'Goal successfully replenished'
      },
      ru: {
        newTransactionLabel: 'Не выбрано',
        fieldRequired: 'Поле обязательно',
        accountFrom: 'Со счёта',
        sum: 'Сумма',
        replenish: 'Пополнить',
        cancel: 'Отмена',
        commissionTip: 'Цель пополняется без комиссии. Если вы хотите указать комиссию, отредактируйте перевод на странице',
        commissionTipNavigation: 'Операции',
        successfullyReplenished: 'Цель успешно пополнена'
      }
    }
  }
}
</script>

<style scoped>
.slide-enter {
  opacity: 0;
}

.slide-leave-active {
  opacity: 0;
}

.slide-enter,
.slide-leave-active {
  opacity: 1;
  transform: translateX(-100%);
}
</style>